/* Ott-common */
import {
  SECONDS_IN_A_MINUTE,
} from '@dtvgo/constants';

export const LAST_IMAGE_DISPLAY_TIME_SECONDS = 3 * SECONDS_IN_A_MINUTE;
